import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpEvent} from "@angular/common/http";
import {Observable} from "rxjs";
import {UploadProductPackagesExcelParams} from "../types/import-product-packages.types";
import {baseUrl} from "../../../../../../../core/constants/base-url";
import {emptyHttpHeaders} from "../../../../../../../core/models/http-headers";

@Injectable({
  providedIn: 'root'
})
export class ImportProductPackagesApiService {
  private http: HttpClient = inject(HttpClient);

  public importProductPackagesExcel(uploadProductPackagesExcelParams: UploadProductPackagesExcelParams): Observable<HttpEvent<void>> {
    const { path, technicalParametersId, file } = uploadProductPackagesExcelParams;

    return this.http.post<void>(`${baseUrl}/${path}`, file, {
      reportProgress: true,
      observe: 'events',
      headers: emptyHttpHeaders,
      params: { technicalParametersId : technicalParametersId  }
    });
  }
}
